module.exports = __webpack_public_path__ + "templates/summaryDialog.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/summary/summaryDialog.html
// module id = 274
// module chunks = 15